
export default {
  // api:  'https://yuhou.aiteyixia.cn/' http://192.168.20.125:8087/  http://test.aiteyixia.cn/
  api: process.env.NODE_ENV === 'development' ? "http://192.168.20.190:8087/" : 'https://yuhou.aiteyixia.cn/'
}


// WEBPACK FOOTER //
// ./src/serve.js